import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Language } from '../models/language.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  constructor(private httpClient: HttpClient) {}

  getLanguageList(): Observable<Language[]> {
    return this.httpClient.get(`${environment.apiUrl}/Core/Language`).pipe(
      take(1),
      map((languageList: Language[]) => {
        return languageList;
      })
    );
  }
}
